import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { CountyResponse } from '../../shared/models/county.model';
import { CountyService } from '../../shared/services/county.service';

@Injectable({
  providedIn: 'root',
})
export class GetCountiesResolver implements Resolve<CountyResponse[]> {
  constructor(private countyService: CountyService) {}

  resolve(): Observable<CountyResponse[]> {
    return this.countyService.getAll();
  }
}
